import { useEffect, useRef, ReactNode } from 'react';

type AnimType = 'fade-up' | 'fade-in' | 'slide-left' | 'slide-right' | 'scale-in';

interface AnimateInProps {
  children: ReactNode;
  animation?: AnimType;
  delay?: number;
  className?: string;
  threshold?: number;
}

const classMap: Record<AnimType, string> = {
  'fade-up': 'anim-fade-up',
  'fade-in': 'anim-fade-in',
  'slide-left': 'anim-slide-left',
  'slide-right': 'anim-slide-right',
  'scale-in': 'anim-scale-in',
};

export function AnimateIn({
  children,
  animation = 'fade-up',
  delay = 0,
  className = '',
  threshold = 0.1,
}: AnimateInProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('is-visible');
          io.unobserve(el);
        }
      },
      { threshold },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);

  return (
    <div
      ref={ref}
      className={`${classMap[animation]} ${className}`}
      style={delay > 0 ? { animationDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
}
